import { render } from "./ContactButton.vue?vue&type=template&id=85b49ae2&scoped=true"
import script from "./ContactButton.vue?vue&type=script&lang=js"
export * from "./ContactButton.vue?vue&type=script&lang=js"

import "./ContactButton.vue?vue&type=style&index=0&id=85b49ae2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-85b49ae2"

export default script